import {ORIENTATION_LOCK_MEDIA_QUERY} from '../../constants/visuals';
import {checkIfPhoneScreen} from './checkIfPhoneScreen';
import {getInterfaceOrientation, INTERFACE_ORIENTATIONS} from './getInterfaceOrientation';

/**
 * Закрыт ли сейчас экран оверлеем «поверните устройство»
 * (OrientationLockOverlay): телефон действительно повернут боком.
 *
 * Одного медиазапроса для этого мало, и по двум причинам.
 *
 * Он срабатывает и на вертикальном телефоне, стоит открыть экранную
 * клавиатуру в браузере, где она сжимает окно (см. getInterfaceOrientation), —
 * оверлей закрывал поле ввода, в которое человек как раз собрался печатать.
 * Поэтому решает системная ориентация: «вертикально» отменяет оверлей.
 *
 * И он не отличает телефон от планшета: тот в горизонтали играет как есть, а
 * по ширине окна их не разделить (см. checkIfPhoneScreen).
 *
 * @returns {boolean}
 */
export const checkIfOrientationLockActive = () => {
  if (typeof window === 'undefined') {
    return false;
  }
  if (!window.matchMedia(ORIENTATION_LOCK_MEDIA_QUERY).matches) {
    return false;
  }
  if (!checkIfPhoneScreen()) {
    return false;
  }
  // null — браузер ориентацию не сообщает (среди мобильных таких не
  // осталось): тогда, как и раньше, остается верить пропорциям окна
  return getInterfaceOrientation() !== INTERFACE_ORIENTATIONS.PORTRAIT;
};
